import React, { Component, PropTypes } from 'react';
import { firstInitialLastName } from '../filters/RecruitFilters';

export default class ShortUserName extends Component {

  render() {
    const { user } = this.props;
    const name = firstInitialLastName(user);

    if (name === '-. -') {
      return <span>{user.initials}</span>;
    } else {
      return <span>{name}</span>;
    }
  }
}

ShortUserName.propTypes = {
  user: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/ShortUserName.jsx